import { Skeleton } from "@/components/ui/skeleton";

export const InvestmentPlanSkeleton = () => {
  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-6 animate-pulse">
      <div className="mb-8">
        <Skeleton className="h-8 w-32 mb-4 bg-gray-700" />
        <Skeleton className="h-4 w-48 bg-gray-700" />
      </div>
      <div className="mb-8">
        <Skeleton className="h-12 w-20 mb-2 bg-gray-700" />
        <Skeleton className="h-6 w-12 bg-gray-700" />
      </div>
      <div className="mb-8 space-y-4">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="flex items-center">
            <Skeleton className="h-6 w-6 rounded-full mr-2 bg-gray-700" />
            <Skeleton className="h-4 w-32 bg-gray-700" />
          </div>
        ))}
      </div>
      <Skeleton className="h-12 w-full rounded-md bg-gray-700" />
    </div>
  );
};

export const InvestmentPlansSkeletonGrid = () => {
  return (
    <div className="mb-8 mt-4 px-4">
      <section className="bg-black py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, index) => (
              <InvestmentPlanSkeleton key={index} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};